module.exports = __webpack_public_path__ + "static/img/A48.b9e4590d.jpg";